import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const approvalWorkflowListService = (
  params: Types.ApprovalWorkflowListRequest
) =>
  RestAPIClient.call<Types.ApprovalWorkflowListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const approvalWorkflowListShortService = (
  params: Types.ApprovalWorkflowListRequest
) =>
  RestAPIClient.call<Types.ApprovalWorkflowListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const approvalWorkflowCreateService = (
  params: Types.ApprovalWorkflowCreateRequest
) =>
  RestAPIClient.call<Types.ApprovalWorkflow>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalWorkflowUpdateService = (
  params: Types.ApprovalWorkflowUpdateRequest
) =>
  RestAPIClient.call<Types.ApprovalWorkflow>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const approvalWorkflowDetailService = (id: string) =>
  RestAPIClient.call<Types.ApprovalWorkflow>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
